import React from 'react';
import { Modal, Button, Space, Typography } from 'antd';
import { PauseCircleOutlined, FlagOutlined, RollbackOutlined } from '@ant-design/icons';
import styles from './navigationConfirmModal.module.scss';

const { Text } = Typography;

const NavigationConfirmModal = ({
    isOpen,
    onPauseAndLeave,
    onEndAndLeave,
    onContinueSession,
    targetPath = ''
}) => {

    const handlePause = () => {
        onPauseAndLeave(targetPath);
    };

    const handleEnd = () => {
        onEndAndLeave(targetPath);
    };

    return (
        <Modal
            title="Leave Current Session?"
            open={isOpen}
            onCancel={onContinueSession}
            footer={null}
            width={480}
            centered
            maskClosable={false}
            className={styles.navigationModal}
        >
            <div className={styles.modalContent}>
                <div className={styles.modalDescription}>
                    <Text>You have an active examination session in progress.</Text>
                    <Text strong>What would you like to do?</Text>
                </div>

                <Space direction="vertical" size="middle" className={styles.buttonGroup}>
                    {onPauseAndLeave && (
                        <Button
                            type="default"
                            size="large"
                            icon={<PauseCircleOutlined />}
                            onClick={handlePause}
                            className={`${styles.actionButton} ${styles.pauseButton}`}
                            block
                        >
                            <div className={styles.buttonContent}>
                                <span className={styles.buttonText}>Pause & Leave</span>
                                <span className={styles.buttonSubtext}>You can resume later</span>
                            </div>
                        </Button>
                    )}

                    <Button
                        type="default"
                        size="large"
                        icon={<FlagOutlined />}
                        onClick={handleEnd}
                        className={`${styles.actionButton} ${styles.endButton}`}
                        block
                        danger
                    >
                        <div className={styles.buttonContent}>
                            <span className={styles.buttonText}>End & Leave</span>
                            <span className={styles.buttonSubtext}>Session will be completed</span>
                        </div>
                    </Button>

                    <Button
                        type="primary"
                        size="large"
                        icon={<RollbackOutlined />}
                        onClick={onContinueSession}
                        className={`${styles.actionButton} ${styles.continueButton}`}
                        block
                    >
                        <div className={styles.buttonContent}>
                            <span className={styles.buttonText}>Stay Here</span>
                            <span className={styles.buttonSubtext}>Continue current session</span>
                        </div>
                    </Button>
                </Space>
            </div>
        </Modal>
    );
};

export default NavigationConfirmModal;